import AppSetting from "../../config/AppSetting";

export default class RequestOption {
  /**
   * @param {string} method
   * @param {obj} headers example
   *   headers: {
   *       'Content-Type': 'application/json',
   *       'Authorization': 'Bearer my-token',
   *       'My-Custom-Header': 'foobar'
   *   }
   * @param {obj} body
   * @param {boolean} requireAuth
   * @param {function} onSuccess
   * @param {function} onError
   */
  constructor(obj: any) {
    const {
      mode,
      method,
      headers,
      body,
      requireAuth,
      onSuccess,
      onError,
      returnPara,
      keepalive,
      noEnCode,
    } = obj;
    // @ts-ignore
    this.mode = mode;
    // @ts-ignore
    this.method = method;
    // @ts-ignore
    this.headers = headers;
    // @ts-ignore
    this.body = body;
    // @ts-ignore
    this.requireAuth = requireAuth;
    // @ts-ignore
    this.onError = onError;
    // @ts-ignore
    this.onSuccess = onSuccess;
    // @ts-ignore
    this.returnPara = returnPara;
    // @ts-ignore
    this.keepalive = keepalive;
    // @ts-ignore
    this.noEnCode = noEnCode;
  }

  checkRequireAuth() {
    if (
      // @ts-ignore
      this.requireAuth &&
      AppSetting.localStorageValue.isAuthenticated.get()
    ) {
      return;
    }

    throw Error("Have not authenticated!");
  }
}
